import React from 'react'
import { Switch } from 'react-router'
import { Redirect, Route } from 'react-router-dom'
import BeneficiarySignUp from '../pages/Beneficiary/Auth/BeneficiarySignUp'
import BeneficiarySignIn from '../pages/Beneficiary/Auth/BeneficiarySignIn'
import BeneficiaryCourses from '../pages/Beneficiary/Courses/BeneficiaryCourses'
import BeneficiaryClasses from '../pages/Beneficiary/Classes/BeneficiaryClasses'
import BeneficiaryProfile from '../pages/Beneficiary/Profile/BeneficiaryProfile'
import BeneficiaryPassword from '../pages/Beneficiary/Password/BeneficiaryPassword'
import BeneficiaryRoute from '../components/Authentication/BeneficiaryRoute'
import { BeneficiaryViewCourseLesson } from '../pages/Beneficiary/Courses/BeneficiaryViewCourseLesson'
import BeneficiaryForgotPassword from '../pages/Beneficiary/Auth/BeneficiaryForgotPassword'
import BeneficiaryResetPassword from '../pages/Beneficiary/Auth/BeneficiaryResetPassword'

const BeneficiaryWrapper = ({ match, location }) => {
    const { path } = match
    const { pathname } = location
    return (
        <Switch>
            <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
            <Route
                path={`${path}/:domainName/invite`}
                component={BeneficiarySignUp}
            />
            <Route
                path={`${path}/:domainName/sign-in`}
                component={BeneficiarySignIn}
            />
            <Route
                path={`${path}/:domainName/forgot-password`}
                component={BeneficiaryForgotPassword}
            />
            <Route
                path={`${path}/:domainName/reset-password`}
                component={BeneficiaryResetPassword}
            />
            <BeneficiaryRoute
                path={`${path}/my-courses/:courseId/:enrollmentId/lessons/:lessonId/:topicId`}
                component={BeneficiaryViewCourseLesson}
            />
            <BeneficiaryRoute
                path={`${path}/my-courses`}
                exact
                component={BeneficiaryCourses}
            />
            <BeneficiaryRoute
                path={`${path}/class`}
                component={BeneficiaryClasses}
            />
            <BeneficiaryRoute
                path={`${path}/settings/profile`}
                component={BeneficiaryProfile}
            />
            <BeneficiaryRoute
                path={`${path}/settings/password`}
                component={BeneficiaryPassword}
            />
            <BeneficiaryRoute
                path={`${path}/settings`}
                render={() => <Redirect to={`${path}/settings/profile`} />}
                exact
            />
        </Switch>
    )
}

export default BeneficiaryWrapper
